export const DEFAULT_FOOTER_HEIGHT_PX = 80;

const prefix = 'hc-step-form-carousel';

export const StepFormCarouselClassNames = {
  Root: `${prefix}-root`,
  StepComponent: `${prefix}-step-component`,
  Footer: `${prefix}-footer`,
};

const varPrefix = `--hc-${prefix}`;

export const StepFormCarouselVariableNames = {
  FooterHeight: `${varPrefix}-footer-height`,
};
